import type {ApiRpcDslQuery, ApiRpcQuery} from './types';

export const prepareQuery = (query: ApiRpcDslQuery | ApiRpcQuery[]) => {
  let result: ApiRpcDslQuery | ApiRpcQuery[];

  if (Array.isArray(query)) {
    result = query.filter(Boolean);
  } else {
    result = {};

    const run = (source: ApiRpcDslQuery, dest: ApiRpcDslQuery) => {
      Object.keys(source).forEach(key => {
        dest[key] = source[key].filter(Boolean).map(item => {
          if (Array.isArray(item)) {
            return item;
          }

          return run(item, item);
        });
      });

      return dest;
    };

    return run(query, result);
  }

  return result;
};
